// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
      	showSuggestionProductVendor: false,
       	suggestionWidth: 300,
      	enableDefaultResult: false
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};

// Build number of Search result
BCSfFilter.prototype.buildSearchResultNumber = function(data) {
    var content = '';
    var searchTerm = getParam(this.searchTermKey);
    if (searchTerm != null) {
        var content = bcSfFilterConfig.label.search_result_number_other;
        if (data.total_product <= 1) {
            var content = bcSfFilterConfig.label.search_result_number_one;
        }
        content = content.replace(/{{ count }}/g, data.total_product).replace(/{{ terms }}/g, getParam(this.searchTermKey));
    }
    jQ('.' + this.class.searchResultNumber).html(content);
};

/***** Customize search & suggestion params *****/
// Prepare Params of Suggestion API
BCSfFilter.prototype.prepareSuggestionParams = function () {
    var params = {};
    params.shop = this.shopDomain;
    params.t = new Date().getTime();
    if (!this.getSettingValue('search.enableDefaultResult')) params.enable_default_result = false;
    if (!this.getSettingValue('search.enableFuzzy')) params.fuzzy = false;
  	params.pf_pt_product_type = 'Master';
    // Skip fields
    var skipFields = this.getSettingValue('search.skipFields');
    if (skipFields.length > 0) {
        param.skipFields = skipFields;
    }
    params.callback = 'BCSfSuggestionCallback';
    return params;
};

// Prepare Search params
BCSfFilter.prototype.prepareSearchParams = function(params, eventType) {
    if (this.isSearchPage()) {
      	console.log('aaa');
        params['q'] = this.escape(this.getSearchTerm());
      	params.pf_pt_product_type = 'Master';
        if (this.searchTermKey != 'q') delete params[this.searchTermKey];
        if (!this.getSettingValue('search.enableFuzzy')) params.fuzzy = false;
    }
    return params;
};

BCSfFilter.prototype.buildSuggestionProductList = function(searchTerm, data, ul) {
    if (Object.keys(data).length > 0) {
        var limit = this.getSettingValue('search.suggestionProductLimit');
        var category = this.getSettingValue('label.suggestion.productHeader');
        // Build content
        var result = this.buildSuggestionHeader(category, 'product');
        var count = 0;

        for (var k in data) {
            if (count < limit) {
                var product = data[k];
              if(product.product_type == 'Master'){
                if (this.getSettingValue('search.productAvailable') === false || 
                    (this.getSettingValue('search.productAvailable') && product.available)) {
                    // Get product attributes
                    var productTitle = this.customizeSuggetionProductTitle(product['title'], searchTerm, data);
                    productTitle = this.highlightSuggestionResult(productTitle, searchTerm);
                    var productUrl = this.buildProductItemUrl(product, false);
                    var productThumb = product['images_info'].length > 0 ? this.optimizeImage(product['images_info'][0]['src'], 'medium') : bcSfFilterConfig.general.no_image_url;
                    var productSku = product.skus !== null && product.skus.length > 0 ? product['skus'][0] : '';
                    // Get custom class / attribute
                    var searchSuggestionClass = this.class.searchSuggestion;
                    var newTabAttr = this.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

                    result += '<li class="' + this.class.searchSuggestionItem + ' ' + this.class.searchSuggestionItem + '-product" aria-label="' + this.escape(category) + ': ' + this.escape(product['title']) + '">';
                    result += '<a href="' + productUrl + '" ' + newTabAttr + '>';
                    // Build Left column
                    if (this.getSettingValue('search.showSuggestionProductImage')) {
                        result += '<div class="' + searchSuggestionClass + '-left"><img src="' + productThumb + '" /></div>';
                    }
                    // Build Right column
                  	var prodTitle = product.title.split('-');
                    prodTitle = prodTitle[1].split('•');
                    prodTitle = prodTitle[0].split('&');
                  
                    result += '<div class="' + searchSuggestionClass + '-right">';
                  	var topprice = this.getProductMetafield(product, 'product', 'topprice') || '';
                    topprice = (topprice) ? bcsffilter.formatMoney(topprice * 100, bcsffilter.moneyFormat) : '';

                    var toppricesale = this.getProductMetafield(product, 'product', 'toppricesale') || '';
                    toppricesale = (toppricesale) ? bcsffilter.formatMoney(toppricesale * 100, bcsffilter.moneyFormat) : '';

                    var bottomprice = this.getProductMetafield(product, 'product', 'bottomprice') || '';
                    bottomprice = (bottomprice) ? bcsffilter.formatMoney(bottomprice * 100, bcsffilter.moneyFormat) : '';

                    var bottompricesale = this.getProductMetafield(product, 'product', 'bottompricesale') || '';
                    bottompricesale = (bottompricesale) ? bcsffilter.formatMoney(bottompricesale * 100, bcsffilter.moneyFormat) : '';
                  
                  	if (toppricesale == '') {
                        result += '<div class="' + searchSuggestionClass + '-product-title">' + prodTitle[0] + ' '+ '<br/><span class="money">' + topprice + '</span> <BR/></div>';
                    } else {
                        result += '<div class="' + searchSuggestionClass + '-product-title">' + prodTitle[0] + ' ' + '<br/><span style="text-decoration: line-through;"><span class=money>' + topprice + '</span></span><span style="color:#a31313"><BR/>Sale: <span class="money">' + toppricesale + '</span></span> <BR/></div>';
                    }

                    if(product.product_type == 'Master' && prodTitle.length > 1){
                        if (bottompricesale == ''){
                            result += '<div class="' + searchSuggestionClass + '-product-title">' + prodTitle[1] + ' '+ '<br/><span class="money">' + bottomprice + '</span></div>';
                        } else {
                            result += '<div class="' + searchSuggestionClass + '-product-title">' + prodTitle[1] + ' ' + '<br/><span style="text-decoration: line-through;"><span class=money>' + bottomprice + '</span></span><span style="color:#a31313"><BR/>Sale: <span class="money">' + bottompricesale + '</span></span></div>';
                        }
                    }
                  
                    if (this.getSettingValue('search.showSuggestionProductSku')) {
                        result += '<div class="' + searchSuggestionClass + '-product-sku">SKU: ' + productSku + '</div>';
                    }
                    if (this.getSettingValue('search.showSuggestionProductVendor')) {
                        result += '<div class="' + searchSuggestionClass + '-product-vendor">' + product['vendor'] + '</div>';
                    }
                    
                    result += '</div>'; // End Right column
                    result += '</a>'; // End a
                    result += '</li>';  // End li

                    count ++;
                }
            } else {
                break;
            }
            }
        }
        return result;
    }
    return '';
};
// Build header of Search result
BCSfFilter.prototype.buildSearchResultHeader = function(data) {
    var searchTerm = this.escape(this.getSearchTerm());
    if (searchTerm !== null && searchTerm != '')  {
        var content = data.total_product > 0 ? this.getSettingValue('label.search.resultHeader') : this.getSettingValue('label.search.resultEmpty');
    } else {
        var content = this.getSettingValue('label.search.generalTitle');
    }
    jQ('.' + this.class.searchResultHeader).html(content.replace(/{{ terms }}/g, searchTerm));
};
// Build number of Search result
BCSfFilter.prototype.buildSearchResultNumber = function(data) {
    var content = '';
    var searchTerm = this.escape(this.getSearchTerm());
    if (searchTerm !== null && searchTerm != '')  {
        content = this.getSettingValue('label.search.resultNumber');
        content = content.replace(/{{ count }}/g, '<strong>' + data.total_product + '</strong>').replace(/{{ terms }}/g, '<strong>' + searchTerm + '</strong>');
    }
    jQ('.' + this.class.searchResultNumber).html(content);
};
  // Prepare Params of Suggestion API
BCSfFilter.prototype.prepareSuggestionParams = function () {
    var params = {};
    params.shop = this.shopDomain;
    params.t = new Date().getTime();
    if (!this.getSettingValue('search.enableDefaultResult')) params.enable_default_result = false;
    if (!this.getSettingValue('search.enableFuzzy')) params.fuzzy = false;
    // Skip fields
    var skipFields = this.getSettingValue('search.skipFields');
    if (skipFields.length > 0) {
        param.skipFields = skipFields;
    }
    params.callback = 'BCSfSuggestionCallback';
    return params;
};
// Fix XSS
BCSfFilter.prototype.customizeSearchTerm = function (searchTerm) {
   return encodeURIParamValue(searchTerm.trim());
};
function BCSfSuggestionCallback(result) {
    suggestionCallback(jQ.map(result, function (item, index) {
        return { key: index, values: item };
    }));
};
// Build Suggestion
BCSfFilter.prototype.buildSuggestion = function(searchTerm, data, ul) {
      searchTerm = this.escape(searchTerm);
    var result = '';
    var blocks = this.getSettingValue('search.suggestionBlocks');
    for (var k = 0; k < blocks.length; k++) {
        var index = this.findIndexArray(blocks[k], data, 'key');
        if (index > -1 && data[index].hasOwnProperty('values') && data[index]['values'].length > 0) {
            switch(blocks[k]) {
                case 'suggestions': result += this.buildSuggestionPopular(searchTerm, data[index]['values'], ul); break;
                case 'products': result += this.buildSuggestionProductList(searchTerm, data[index]['values'], ul); break;
                case 'did_you_mean': result += this.buildSuggestionDidYouMeanList(searchTerm, data[index]['values'], ul); break;
            }
        }
    }
    if (result != '') {
        result += this.buildSuggestionViewAll(searchTerm, data, ul);
    }
    jQ(ul).append(result);

    // Wrapper
    this.buildSuggestionWrapper(ul);
};
// Highlight Text in the Search result
BCSfFilter.prototype.highlightSuggestionResult = function(resultItem, searchTerm) {
    if (this.getSettingValue('search.highlightSuggestionResult') && searchTerm.length > 1) {
        // Find words that are the same with the Search term
        var termElements = searchTerm.split(' ');
        for (var i = 0; i < termElements.length; i++) {
            // Escape the following characters: ( ) { } and .
            var reg = new RegExp(termElements[i].replace(/([(){}.])/g, '\$&'), 'ig');
            var foundWords = resultItem.match(reg);
            if (foundWords !== null && foundWords.length > 0) {
                // Remove duplicate values
                foundWords = foundWords.filter(function(item, pos) {
                    return foundWords.indexOf(item) == pos && item != '';
                })
                // Highlight the above words
                for (var k in foundWords) {
                    if (foundWords[k].length > 1) {
                        var reg = new RegExp(foundWords[k], 'g');
                        resultItem = resultItem.replace(reg, '<b>' + foundWords[k] + '</b>');
                    }
                }
            }
        }
    }
    return resultItem;
};
BCSfFilter.prototype.getSearchTerm = function() {
    return getParam(this.searchTermKey);
};